import { Toastr } from 'components/global/Toastr'
import { handleResponseErr } from 'utils/apiHelperUtils'
import I18n from 'translations/i18n'
import * as actions from './actions'

export const initialState = {
  fetching: false,
  fetching_share: false,
  fetching_draft: false,
  payrun: {},
  header: [],
  records: [],
  employees_ids: [],
  total: [],
  filters: {
    department_ids: [],
    location_ids: [],
    employment_type_ids: [],
    business_unit_ids: [],
  },
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actions.PAYROLL_REPORT_LOAD_PENDING: {
      return {
        ...state,
        fetching: true,
      }
    }

    case actions.PAYROLL_REPORT_SHARE_PENDING: {
      return {
        ...state,
        fetching_share: true,
      }
    }

    case actions.PAYROLL_REPORT_LOAD_FULFILLED: {
      return {
        ...state,
        ...action.payload.data.data,
        fetching: false,
      }
    }

    case actions.PAYROLL_REPORT_SHARE_FULFILLED: {
      Toastr.success(I18n.t('email_sent_successfully'))
      return {
        ...state,
        fetching_share: false,
      }
    }

    case actions.PAYROLL_REPORT_SHARE_REJECTED:
    case actions.PAYROLL_REPORT_LOAD_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching: false,
        fetching_share: false,
      }
    }

    case actions.SET_FILTERS_PAYROLL: {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.filters,
        },
      }
    }

    case actions.CLEAR_FILTERS_PAYROLL: {
      return {
        ...state,
        filters: initialState.filters,
      }
    }

    case actions.PAYROLL_REDRAFT_PENDING: {
      return {
        ...state,
        fetching_draft: true,
      }
    }

    case actions.PAYROLL_REDRAFT_FULFILLED:
      Toastr.success(action.payload.data.message)
      return {
        ...state,
        fetching_draft: false,
      }

    case actions.PAYROLL_REDRAFT_REJECTED: {
      Toastr.error(handleResponseErr(action.payload))
      return {
        ...state,
        fetching_draft: false,
      }
    }

    default:
      return state
  }
}
